/**
 * Бекенд зберігає всі часові мітки в БД як naive UTC (ISO-рядок без "Z"
 * і без офсету, напр. "2026-09-06T13:21:17.060998"). Якщо просто зробити
 * new Date(рядок) — JS трактує рядок БЕЗ офсету як ЛОКАЛЬНИЙ час пристрою,
 * а не UTC. Тому час "пливе": показується сира UTC-цифра, як є, без
 * перерахунку — на 3 години менше за реальний київський час.
 *
 * Ці хелпери завжди повертають час/дату в Києві (Europe/Kyiv, з урахуванням
 * переходу на літній/зимовий час), незалежно від того, в якому часовому
 * поясі фізично знаходиться браузер глядача.
 */

const KYIV_TZ = "Europe/Kyiv";

/** Дописує "Z", якщо в рядку ще немає офсету — щоб new Date() зрозумів, що це UTC. */
function asUtcDate(value) {
  if (!value) return null;
  let s = value;
  if (s instanceof Date) return s;
  s = String(s);
  if (!/[Zz]$|[+-]\d{2}:?\d{2}$/.test(s)) {
    s = s + "Z";
  }
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

/** "06.09.2026, 16:21:17" (або з переданими опціями toLocaleString) */
export function formatKyivDateTime(value, locale = "ru-RU", opts) {
  const d = asUtcDate(value);
  if (!d) return "—";
  return d.toLocaleString(locale, { timeZone: KYIV_TZ, ...opts });
}

/** "06.09.2026" (або з переданими опціями toLocaleDateString) */
export function formatKyivDate(value, locale = "ru-RU", opts) {
  const d = asUtcDate(value);
  if (!d) return "—";
  return d.toLocaleDateString(locale, { timeZone: KYIV_TZ, ...opts });
}

/** "16:21:17" (за замовчуванням) або з переданими опціями toLocaleTimeString */
export function formatKyivTime(value, locale = "ru-RU", opts) {
  const d = asUtcDate(value);
  if (!d) return "—";
  return d.toLocaleTimeString(locale, { timeZone: KYIV_TZ, ...opts });
}

/**
 * Правильний Date-об'єкт з рядка бекенду — для арифметики (різниця в днях/
 * годинах тощо), а не тільки для показу. Без цього "скільки днів тому" теж
 * плаває на ±3 години біля півночі.
 */
export function toUtcDate(value) {
  return asUtcDate(value);
}
